import noPicture from '@/asset/no-picture.png';

export const getHeadPicture = (value) => {
  return <span>
    <img src={value || noPicture} className='feishu-head-picture' />
  </span>;
};
